var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 70,
    viewBox: "0 0 87 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 504",
    d: "M80.8494 8.66174H35.6084M45.0944 60.1052L55.3101 56.4567",
    stroke: "#7646D7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 503",
    d: "M44.0946 33.4591L22.5243 4.49664C21.4489 3.05261 22.4795 1 24.28 1H81.9625C83.763 1 84.7936 3.05261 83.7182 4.49665L62.1479 33.4591C61.8665 33.837 61.7145 34.2955 61.7145 34.7667V59.0116C61.7145 59.9714 61.0893 60.8193 60.1724 61.1029L47.3641 65.0654C45.9557 65.5011 44.528 64.4483 44.528 62.9741V34.7667C44.528 34.2955 44.376 33.837 44.0946 33.4591Z",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 501",
    d: "M27.3055 68.1318L1.67773 35.7599L11.1195 23.6205H43.941L52.9332 35.7599L27.3055 68.1318Z",
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 502"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3077 62.7366L16.9667 34.8608L27.3077 24.0702H42.5945L37.6488 34.8608L27.3077 62.7366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1218 24.9694L16.9667 34.8608M16.9667 34.8608L27.3077 62.7366L37.6488 34.8608M16.9667 34.8608L27.3077 24.0702M37.6488 34.8608L42.5945 24.0702H27.3077M37.6488 34.8608L27.3077 24.0702M3.02881 34.8608H52.4859",
    stroke: "#7646D7",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.8ccc0d3d66fc0e91f62f4e6ccb0ff4dd.svg";
export { ForwardRef as ReactComponent };